import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/WeChat.png'


const _withScopeId = n => (_pushScopeId("data-v-82d7f0f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "top-list personal-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "个人中心"),
  /*#__PURE__*/_createElementVNode("span", null, "为系统中管理账户和查看个人信息提供便捷服务。")
], -1))
const _hoisted_5 = { class: "main" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "微信支付")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
    /*#__PURE__*/_createTextVNode("微信扫码"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("快捷支付")
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  class: "remit"
}
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 实付金额：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 微信扫码支付 ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "如已完成支付，30s内未收到检测次数，请刷新页面", -1))
const _hoisted_13 = {
  key: 1,
  class: "remit-success"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "支付成功", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "将在5s后自动跳转到历史记录页面", -1))
const _hoisted_16 = { class: "person-info" }
const _hoisted_17 = {
  key: 0,
  class: "bind"
}
const _hoisted_18 = {
  key: 1,
  class: "no-bind"
}
const _hoisted_19 = {
  key: 2,
  class: "referral-code"
}
const _hoisted_20 = { class: "receive" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "即日起，新用户绑定手机并完善个人信息有机会获得若干次免费试用机会", -1))
const _hoisted_22 = {
  key: 0,
  class: "block"
}

import { ref, reactive, onMounted, onUnmounted, watch } from "vue";
import {
  sendSms,
  checkCode,
  resetPaw,
  getUser,
  checknumCombo,
  checknumRecharge,
  checknumRecord,
  queryPayResult,
  getSchool,
  updateUser,
  getFreeNum,
  SaveReferralCode,
} from "@/service/personalCenter/request.js";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import type { FormInstance, FormRules, TabsPaneContext } from "element-plus";
import md5 from "js-md5";
import QrcodeVue from "qrcode.vue";
import { setLocal, debounce, clearTimer } from "@/service/common.js";
import mitt from "@/service/mitt.js";
import { Label, LoveAndHelp } from "@icon-park/vue-next";


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalCenter',
  setup(__props) {

const router = useRouter();
const activeName = ref("first");
const orderRadio = ref(); // 默认充值套餐
const wayRadio = ref(); // 支付方式
const disable = ref(false); // 发送验证码按钮是否禁用
const text = ref("获取验证码");
const timerCode = ref(null); // 发送验证码定时器
const timeCode = ref(0); // 发送验证码倒计时
const rulePhoneRef = ref<FormInstance>();
const rulePassRef = ref<FormInstance>();
const regPhone = /^1[3-9][0-9]{9}$/; // 手机号正则
const regPass = /^[A-Za-z0-9]{6,10}$/; // 密码正则
const recordData = ref([]); // 消费记录
const recharge = ref([]); // 充值次数
const orderId = ref(); // 充值次数id
const orderPrice = ref(); // 充值套餐价格
const codeUrl = ref(); // 支付二维码
const payWay = ref(); // 支付方式
const isShow = ref(false); // 是否显示支付订单
const isSuccess = ref(true); // 是否显示支付成功
const orderNumber = ref(); // 支付订单号
const timer = ref(null); // 查询支付状态定时器
const payStatus = ref(); // 支付状态
const timerJump = ref(null); // 支付成功倒计时5s跳转定时器
const resetPassDialog = ref(false); // 重置密码弹窗
const bindPhoneDialog = ref(false); // 绑定手机弹窗
const schools = ref([]); // 所有学校
const referralCode = ref(""); // 推荐码
const rulePersonRef = ref<FormInstance>();
const loading = ref(true);
// 区别发送验证码类型
const codeType = reactive({
  type1: 1, // 绑定
  type2: 2, // 重置
});

// 用户角色
const roles = [
  {
    value: "本科",
    label: "本科",
  },
  {
    value: "硕士",
    label: "硕士",
  },
  {
    value: "博士",
    label: "博士",
  },
  {
    value: "教授",
    label: "教授",
  },
  {
    value: "教务工作者",
    label: "教务工作者",
  },
  {
    value: "其他",
    label: "其他",
  },
];

// 个人信息
const personForm = reactive({
  name: "",
  role: "",
  school: null,
});

// 用户信息
const userInfo = reactive({
  checkNum: "",
  userName: "",
  phone: "",
  nickName: "",
  identity: "",
  school: "",
  agentReferralCode: "",
});

// 绑定手机信息
const phoneForm = reactive({
  phone: "",
  password: "",
  code: "",
});

// 分页
const queryInfo = reactive({
  pagenum: 1, // 当前页码
  pagesize: 8, // 每页显示条数
  total: 0, // 总条数
});

// 自定义检验规则
const validPhone = (rule: any, value: any, callback: any) => {
  if (regPhone.test(value)) {
    callback();
  }
  callback(new Error("手机号格式有误，请重新检查！"));
};

const validPass = (rule: any, value: any, callback: any) => {
  if (regPass.test(value)) {
    callback();
  }
  callback(new Error("密码格式有误，请重新检查！"));
};

// 手机号密码校验规则
const rules = reactive<FormRules>({
  phone: [
    { required: true, message: "手机号不能为空", trigger: "blur" },
    { validator: validPhone, trigger: "blur" },
  ],
  password: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 6, max: 10, message: "密码位数只能在6~10之间", trigger: "blur" },
    { validator: validPass, trigger: "blur" },
  ],
  code: [{ required: true, message: "验证码不能为空", trigger: "change" }],
});

// 个人信息检验规则
const personRules = reactive<FormRules>({
  name: [{ required: true, trigger: "blur" }],
  role: [{ required: true, trigger: "change" }],
  school: [{ required: true, trigger: "change" }],
});

// 获取用户信息
const getUserInfo = async () => {
  const res = await getUser();
  if (res && res.code && res.code == 200) {
    userInfo.checkNum = res.data.checkNum;
    userInfo.userName = res.data.name;
    userInfo.phone = res.data.userName;
    userInfo.agentReferralCode = res.data.agentReferralCode;
    phoneForm.phone = res.data.userName;
    personForm.name = res.data.nickName ?? "";
    personForm.role = res.data.identity ?? "";
    personForm.school = res.data.school ?? null;
    //调用传值
    mitt.emit("checkNum", userInfo.checkNum);
    setLocal("checkNum", userInfo.checkNum);
  }
};

// 点击去绑定弹窗
function handBind() {
  bindPhoneDialog.value = true;
}

// 点击重置密码弹窗
function handPass() {
  resetPassDialog.value = true;
}

// 获取短信验证码
const getCode = async (type) => {
  if (regPhone.test(phoneForm.phone)) {
    let params = { cOr: type, phone: phoneForm.phone };
    // 调用发送验证码
    const res = await sendSms(params);
    if (res && res.code && res.code == 200) {
      disable.value = true;
      timeCode.value = 60;
      text.value = timeCode.value + "s后重新发送";
      timerCode.value = setInterval(() => {
        timeCode.value--;
        text.value = timeCode.value + "s后重新发送";
        if (timeCode.value <= 0) {
          clearInterval(timerCode.value);
          disable.value = false;
          text.value = "发送验证码";
        }
      }, 1000);
    }
  } else {
    ElMessage.warning("请先输入有效手机号");
  }
};

// 绑定手机号保存
const handSave = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      let params = {
        code: phoneForm.code,
        password: md5(phoneForm.password),
        phone: phoneForm.phone,
      };
      const res = await checkCode(params);
      if (res && res.code && res.code == 200) {
        getUserInfo();
        text.value = "发送验证码";
        disable.value = false;
        bindPhoneDialog.value = false;
        ElMessage.success("绑定成功");
        formEl.resetFields();
      } else {
        ElMessage.warning(res.msg);
      }
    } else {
      return false;
    }
  });
};

// 重置密码
const handReset = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      let params = {
        code: phoneForm.code,
        password: md5(phoneForm.password),
        phone: phoneForm.phone,
      };
      const res = await resetPaw(params);
      if (res && res.code && res.code == 200) {
        ElMessage.success("重置成功");
        formEl.resetFields();
        resetPassDialog.value = false;
      } else {
        ElMessage.warning(res.msg);
      }
    } else {
      return false;
    }
  });
};

// 获取充值次数列表
const getChecknumCombo = async () => {
  const res = await checknumCombo();
  if (res && res.code && res.code == 200) {
    recharge.value = res.data.records ?? [];
    // 默认选中次数价格
    orderRadio.value = res.data.records[0];
    orderPrice.value = res.data.records[0]?.price;
    orderId.value = res.data.records[0]?.id;
  }
  loading.value = false;
};

// 选择充值次数
const handleOrderRadioChanges = (item) => {
  orderId.value = item.id;
  orderPrice.value = item.price;
  if (payWay.value) orderRecharge();
};

// 选择支付方式
const handleWayRadioChanges = async (val) => {
  payWay.value = val;
  orderRecharge();
};

// 下单充值
const orderRecharge = async () => {
  clearTimer(timer.value);
  let params = { id: orderId.value, payType: payWay.value };
  const res = await checknumRecharge(params);
  if (res && res.code && res.code == 200) {
    if (res.data.result) {
      isShow.value = true;
      codeUrl.value = res.data.payInfo.codeUrl;
      orderNumber.value = res.data.orderNumber;
      timer.value = setInterval(() => {
        setTimeout(() => {
          getQueryPayResult();
        }, 0);
      }, 2000);
    } else {
      isShow.value = false;
      ElMessage.error(res.data.msg);
    }
  }
};

// 查询支付状态
const getQueryPayResult = async () => {
  const res = await queryPayResult(orderNumber.value);
  if (res && res.code && res.code == 200) {
    payStatus.value = res.data.status;
  } else {
    ElMessage.error("支付异常");
  }
};

// 获取消费记录
const getChecknumRecord = async () => {
  let params = {
    currentPage: queryInfo.pagenum,
    pageSize: queryInfo.pagesize,
  };
  const res = await checknumRecord(params);
  if (res && res.code && res.code == 200) {
    queryInfo.total = res.data.total;
    recordData.value = res.data.records;
  } else {
    ElMessage.error(res.data.msg);
  }
  loading.value = false;
};

function handleCurrentChange(newPage) {
  queryInfo.pagenum = newPage;
  getChecknumRecord();
}

// 监听支付状态
watch(
  payStatus,
  (newVal) => {
    if (newVal == "SUCCESS") {
      clearTimer(timer.value);
      isSuccess.value = false;
      getUserInfo();
      timerJump.value = setTimeout(() => {
        router.push("/history");
      }, 5000);
    }
  },
  { immediate: true }
);

// 切换tab事件
const tabClick = (tab: TabsPaneContext, event: Event) => {
  if (tab.index == "1") getAllSchool();
  if (tab.index == "2") {
    loading.value = true;
    getChecknumRecord();
  }
};

// 获取所有学校
const getAllSchool = async () => {
  const res = await getSchool();
  if (res && res.code && res.code == 200) {
    schools.value = res.data.schools.map((item) => ({
      value: item,
      label: item,
    }));
  }
};

// 保存个人信息
const handSaveInfo = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      let data = {
        nickName: personForm.name,
        identity: personForm.role,
        school: personForm.school,
      };
      const res = await updateUser(data);
      if (res && res.code && res.code == 200) {
        getUserInfo();
        ElMessage.success("保存成功");
      } else {
        ElMessage.error(res.data);
      }
    } else {
      ElMessage.warning("请填写完整信息");
    }
  });
};

// 获取免费次数
const getFreeNumber = async () => {
  const res = await getFreeNum();
  if (res && res.code && res.code == 200) {
    getUserInfo();
    ElMessage.success(res.msg);
  } else {
    ElMessage.error(res.msg);
  }
};

// 点击领取添加防抖
const handGetNumber = debounce(getFreeNumber, 500);

// 推荐码提交
const handSubmit = async () => {
  if (!referralCode?.value.trim()) {
    ElMessage.warning("推荐码不能为空");
    return;
  }

  try {
    let data = { code: referralCode.value };
    const res = await SaveReferralCode(data);
    if (res && res.code && res.code == 200) {
      getUserInfo();
      ElMessage.success(res.msg || "提交成功");
    } else {
      ElMessage.error(res.msg);
    }
  } catch (error) {
    ElMessage.error("提交失败");
  }
};

onMounted(() => {
  getUserInfo();
  getChecknumCombo();
});

onUnmounted(() => {
  clearTimer(timer.value);
  clearTimer(timerJump.value);
  clearTimer(timerCode.value);
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_dotIcon = _resolveComponent("dotIcon")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          class: "card",
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { shadow: "never" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_tabs, {
                "tab-position": "top",
                modelValue: activeName.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((activeName).value = $event)),
                onTabClick: tabClick
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: "账户充值",
                    name: "first",
                    "element-loading-text": "加载中..."
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_avatar, {
                                shape: "square",
                                size: 50,
                                src: require('@/assets/img/avatar.png')
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: "20" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h5", null, _toDisplayString(userInfo.phone ? userInfo.phone : userInfo.userName), 1),
                              _createElementVNode("p", null, [
                                _createTextVNode(" 检测次数剩余："),
                                _createElementVNode("strong", null, _toDisplayString(userInfo.checkNum), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_divider),
                      _createVNode(_component_el_form, {
                        "label-width": "100px",
                        "label-position": "right",
                        class: "account-form"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "充值说明：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("检测次数只能用于文品易通检测产品，且仅支持在本网站使用。")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "充值次数：" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recharge.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_radio_group, {
                                  size: "large",
                                  "text-color": "#fff",
                                  modelValue: orderRadio.value,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderRadio).value = $event)),
                                  key: item.id,
                                  onChange: _cache[1] || (_cache[1] = ($event: any) => (handleOrderRadioChanges(orderRadio.value)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio, {
                                      label: item,
                                      border: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.title), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: " 支付方式：",
                            class: "payment-method"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_group, {
                                size: "large",
                                modelValue: wayRadio.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((wayRadio).value = $event)),
                                onChange: handleWayRadioChanges
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio, {
                                    label: "1",
                                    border: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (isShow.value)
                        ? (_openBlock(), _createBlock(_component_el_card, {
                            key: 0,
                            "body-style": { background: '#f8f9fb' },
                            shadow: "never"
                          }, {
                            default: _withCtx(() => [
                              (isSuccess.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(QrcodeVue, { value: codeUrl.value }, null, 8, ["value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                      _createElementVNode("p", null, [
                                        _hoisted_10,
                                        _createElementVNode("strong", null, "¥" + _toDisplayString(orderPrice.value) + "元", 1)
                                      ]),
                                      _hoisted_11,
                                      _hoisted_12
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CircleCheck)
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_14,
                                    _hoisted_15
                                  ]))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })), [
                    [_directive_loading, loading.value]
                  ]),
                  _createVNode(_component_el_tab_pane, {
                    label: "个人资料",
                    name: "second"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_el_row, { gutter: 20 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: "4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_avatar, {
                                  shape: "square",
                                  size: 50,
                                  src: require('@/assets/img/avatar.png')
                                }, null, 8, ["src"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: "20" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", null, _toDisplayString(userInfo.phone ?? userInfo.userName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_divider),
                        _createVNode(_component_el_row, { gutter: 20 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: "4",
                              class: "pr-30"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("个人信息")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: "20" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form, {
                                  "hide-required-asterisk": true,
                                  "show-message": false,
                                  inline: true,
                                  model: personForm,
                                  rules: personRules,
                                  ref_key: "rulePersonRef",
                                  ref: rulePersonRef,
                                  class: "form-inline"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "姓名",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: personForm.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((personForm.name) = $event)),
                                          modelModifiers: { trim: true },
                                          maxlength: "8",
                                          placeholder: "请填写",
                                          clearable: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "角色",
                                      prop: "role"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: personForm.role,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((personForm.role) = $event)),
                                          placeholder: "请选择",
                                          clearable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(roles, (item) => {
                                              return _createVNode(_component_el_option, {
                                                label: item.label,
                                                key: item.value,
                                                value: item.value
                                              }, null, 8, ["label", "value"])
                                            }), 64))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "学校",
                                      prop: "school"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select_v2, {
                                          modelValue: personForm.school,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((personForm.school) = $event)),
                                          options: schools.value,
                                          placeholder: "请选择",
                                          clearable: "",
                                          filterable: ""
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          color: "#0054fe",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (handSaveInfo(rulePersonRef.value)))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("保存")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["model", "rules"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_divider)
                      ]),
                      (userInfo.phone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_el_row, { gutter: 20 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: "4",
                                  class: "pr-54"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("手机")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: "20" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_link, { underline: false }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { class: "font-26" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_SuccessFilled)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode("已绑定: " + _toDisplayString(userInfo.phone), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider),
                            _createVNode(_component_el_row, { gutter: 20 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: "4",
                                  class: "pr-26"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("账号密码")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: "20" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_link, { underline: false }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { class: "font-26" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_SuccessFilled)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode("已设置 ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      color: "#0054fe",
                                      onClick: handPass
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("重置密码")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_el_row, { gutter: 20 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: "4",
                                  class: "pr-40"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("手机号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: "20" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_link, {
                                      underline: false,
                                      onClick: handBind
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { class: "font-26" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WarningFilled)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode("去绑定 ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider)
                          ])),
                      (!userInfo.agentReferralCode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_el_row, { gutter: 20 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: "4",
                                  class: "pr-40"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("推荐码")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: "20" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: referralCode.value,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((referralCode).value = $event)),
                                      placeholder: "请输入推荐码",
                                      clearable: ""
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_el_button, { onClick: handSubmit }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("提交")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _hoisted_21,
                            _createVNode(_component_el_button, {
                              color: "#0054fe",
                              onClick: _unref(handGetNumber)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("点击领取次数")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: "消费记录",
                    name: "third",
                    "element-loading-text": "加载中..."
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        data: recordData.value,
                        style: {"width":"100%"},
                        "row-style": {
                    height: '60px',
                    color: 'rgba(116, 121, 140, 1)',
                  },
                        "header-row-style": {
                    height: '60px',
                    color: '#9BA2AB',
                  }
                      }, {
                        empty: _withCtx(() => [
                          _createVNode(_component_el_empty, { description: "暂无数据" })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "orderNumber",
                            label: "订单编号",
                            align: "center",
                            width: "200px"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "orderDesc",
                            label: "订单描述",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "payTime",
                            label: "消费时间",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "price",
                            label: "消费金额",
                            align: "center"
                          }),
                          _createTextVNode(". "),
                          _createVNode(_component_el_table_column, {
                            prop: "payStatus",
                            label: "支付状态",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.payStatus == 0)
                                ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, { class: "unpaid-color" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_dotIcon)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" 未支付 ")
                                    ]),
                                    _: 1
                                  }))
                                : (scope.row.payStatus == 1)
                                  ? (_openBlock(), _createBlock(_component_el_text, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { class: "paiding-color" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_dotIcon)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" 支付中 ")
                                      ]),
                                      _: 1
                                    }))
                                  : (scope.row.payStatus == 2)
                                    ? (_openBlock(), _createBlock(_component_el_text, { key: 2 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { class: "paid-color" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_dotIcon)
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" 已支付 ")
                                        ]),
                                        _: 1
                                      }))
                                    : (scope.row.payStatus == 3)
                                      ? (_openBlock(), _createBlock(_component_el_text, { key: 3 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, { class: "refunding-color" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_dotIcon)
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" 退款中 ")
                                          ]),
                                          _: 1
                                        }))
                                      : (scope.row.payStatus == 4)
                                        ? (_openBlock(), _createBlock(_component_el_text, { key: 4 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { class: "refunded-color" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_dotIcon)
                                                ]),
                                                _: 1
                                              }),
                                              _createTextVNode(" 已退款 ")
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_el_text, { key: 5 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { class: "canceled-color" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_dotIcon)
                                                ]),
                                                _: 1
                                              }),
                                              _createTextVNode(" 已取消 ")
                                            ]),
                                            _: 1
                                          }))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "payType",
                            label: "支付方式",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.payType == 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" 微信扫码 ")
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data", "row-style"]),
                      (recordData.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_el_pagination, {
                              background: "",
                              onCurrentChange: handleCurrentChange,
                              "default-page-size": queryInfo.pagesize,
                              "current-page": queryInfo.pagenum,
                              total: queryInfo.total,
                              "default-current-page": queryInfo.pagenum,
                              "hide-on-single-page": false,
                              layout: "prev, pager, next",
                              "next-icon": "arrow-rightIcon",
                              "prev-icon": "arrow-leftIcon"
                            }, null, 8, ["default-page-size", "current-page", "total", "default-current-page"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })), [
                    [_directive_loading, loading.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode(_component_el_dialog, {
              modelValue: resetPassDialog.value,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((resetPassDialog).value = $event)),
              title: "重置密码",
              width: "25%",
              center: "",
              modal: "",
              "destroy-on-close": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  "label-position": "right",
                  "label-width": "70px",
                  size: "large",
                  style: {"max-width":"400px"},
                  class: "reset-form",
                  model: phoneForm,
                  rules: rules,
                  ref_key: "rulePhoneRef",
                  ref: rulePhoneRef,
                  "hide-required-asterisk": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "手机号",
                      prop: "phone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: phoneForm.phone,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((phoneForm.phone) = $event)),
                          modelModifiers: { trim: true },
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "验证码",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "no-wrap" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: phoneForm.code,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((phoneForm.code) = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "短信验证码",
                              style: {"padding-right":"10px"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              color: "#0054fe",
                              disabled: disable.value,
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (getCode(codeType.type2)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(text.value), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "新密码",
                      prop: "password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: phoneForm.password,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((phoneForm.password) = $event)),
                          modelModifiers: { trim: true },
                          type: "password",
                          placeholder: "6-10位数字或字母组合",
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          color: "#0054fe",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (handReset(rulePhoneRef.value)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("确认重置")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_dialog, {
              modelValue: bindPhoneDialog.value,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((bindPhoneDialog).value = $event)),
              title: "绑定手机",
              width: "25%",
              center: "",
              modal: "",
              "destroy-on-close": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  "label-position": "right",
                  "label-width": "70px",
                  size: "large",
                  style: {"max-width":"400px"},
                  class: "phone-form",
                  model: phoneForm,
                  rules: rules,
                  ref_key: "rulePhoneRef",
                  ref: rulePhoneRef,
                  "hide-required-asterisk": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "手机号",
                      prop: "phone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: phoneForm.phone,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((phoneForm.phone) = $event)),
                          modelModifiers: { trim: true },
                          placeholder: "请输入手机号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "密码",
                      prop: "password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: phoneForm.password,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((phoneForm.password) = $event)),
                          modelModifiers: { trim: true },
                          type: "password",
                          placeholder: "设置登录密码(6-10位数字或字母组合)",
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "验证码",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "no-wrap" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: phoneForm.code,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((phoneForm.code) = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "短信验证码",
                              style: {"padding-right":"10px"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              color: "#0054fe",
                              disabled: disable.value,
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (getCode(codeType.type1)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(text.value), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          color: "#0054fe",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (handSave(rulePhoneRef.value)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("保存")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})